import useLiveContext from '../../../../LiveContext/useLiveContext';
import ComplianceChecklistItem from './Components/ComplianceChecklistItem';
import StyledBox from './styles';

export default function CompliancePanel() {
  const { sessionState: { compliance: topics } } = useLiveContext();

  if (!topics.length) {
    return <div />;
  }

  return (
    <StyledBox>
      {topics.map((topic) => (<ComplianceChecklistItem item={topic} key={topic.textLower} />))}
    </StyledBox>
  );
}
